import classes from "./LoadMore.module.scss";
import ArrowWrapper from "./ArrowWrapper/ArrowWrapper";

type Props = {
  onClick: () => void;
  loading?: boolean;
  title?: string;
};

function LoadMore({ onClick }: Props) {
  return (
    <>
      <div className={classes["dashed-seperator"]}></div>

      <button className={classes["load-more-btn"]} onClick={onClick}>
        Load More
        <ArrowWrapper />
      </button>
    </>
  );
}

export default LoadMore;
